import { useEffect } from 'react';
import amplitude from 'amplitude-js';

export const usePageViewTracker = (page) => {
  useEffect(() => {
    amplitude.getInstance().logEvent(`page_view/${page}`);
  }, [page]);
};
